import { useTranslation } from 'react-i18next';

import { BlockingReasonRow } from './BlockingReasonRow';
import { BlockingReasonAction } from './_types';


export function RequiredFormReason({
  actions,
  resolved = false,
}: {
  actions?: BlockingReasonAction[];
  resolved?: boolean;
}) {
  const { t } = useTranslation('translation', { keyPrefix: 'checkinBlocker' });

  return (
    <BlockingReasonRow
      title={t('blockingReasons.formsRequired.title')}
      message={t('blockingReasons.formsRequired.message')}
      actions={resolved ? undefined : actions}
      color={resolved ? 'success' : 'error'}
    />
  );
}
